import React, { useEffect, useState } from "react";
import "./Shop.css"
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Demo_Product from "../home/demo_product/Demo_Product";
import All_Product from "./all_Product/All_Product";
import Faq from "./faq/Faq";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../features/master/masterSlice";

import { getAllProducts } from "../../features/products/productsSlice";
import { getHomeBanner } from "../../features/home/homeSlice";


function Shop() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "ALL PRODUCTS", link: "", isActive: true },
  ];

  const products = [
    {
      name: "New Launch",
      imgSrc: "/assets/images/demo_product/new_Launch.png",
    },
    { name: "Bilona Cow Ghee", imgSrc: "/assets/images/demo_product/ghee.png" },
    { name: "Kalanmak Rice", imgSrc: "/assets/images/demo_product/rice.png" },
    {
      name: "Desi Tuar Dal",
      imgSrc: "/assets/images/demo_product/daal.png",
    },
    {
      name: "Black Turmeric",
      imgSrc: "/assets/images/demo_product/ginger.png",
    },
    {
      name: "Kasturi Haldi",
      imgSrc: "/assets/images/demo_product/termeric.png",
    },

    {
      name: "Breakfast & Snack",
      imgSrc: "/assets/images/demo_product/Breakfast_and_Snack.png",
    },
    {
      name: "Summer Essentials",
      imgSrc: "/assets/images/demo_product/cocktail.png",
    },
  ];

 const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);




  const breakpoints = {
    485: { slidesPerView: 5 },
    768: { slidesPerView: 6 },
    992: { slidesPerView: 6 },
    1024: { slidesPerView: 7 },
  };


  const [selectId,setSelectId]=useState();


  
  return (
    <>
      <section className="Shop">

        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        <Demo_Product products={category} breakpoints={breakpoints} selectId={selectId} setSelectId={setSelectId}/>

        {/* <All_Product products={filterproduct}  /> */}
        <All_Product selectId={selectId} />

        {/* <Faq /> */}

        {/* <Stay_Connected /> */}
      </section>
    </>
  );
}

export default Shop;
